import { Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmModalComponent, NotificationsService, PageComponent } from 'projects/libraries/syslink-components/src/public-api';
import { ContextMenuItemAction } from 'projects/libraries/syslink-components/src/lib/context-menus/context-menu-item-action';
import { ContextMenuItemClickEvent } from 'devextreme/ui/file_manager';
import { DocumentCreateModalComponent } from '../../../base/documents/document-create-modal/document-create-modal.component';
import { StockMoveInternalGridComponent } from '../stock-move-internal-grid/stock-move-internal-grid.component';
import { StockMoveInternalStatusSelectModalComponent } from '../stock-move-internal-status/stock-move-internal-status-select-modal/stock-move-internal-status-select-modal.component';
import { StockMoveInternalContextMenuItemActionCode, StockMoveInternalsService } from './stock-move-internals.service';
import { StockMoveInternalHeaderHeaderStatusesService } from '../stock-move-internal-header-header-statuses/stock-move-internal-header-header-statuses.service';
import { StockMoveInternal } from './stock-move-internal.model';
import { StockMoveInternalHeaderStatus } from '../stock-move-internal-header-statuses/stock-move-internal-header-status.model';
import { AuthService } from '../../../core/auth/auth.service';
import { AppInjectorService } from 'projects/libraries/syslink-components/src/lib/services/app-injector.service';

@Component({
  selector: 'app-stock-move-internals',
  templateUrl: './stock-move-internals.component.html',
  styleUrls: ['./stock-move-internals.component.scss']
})
export class StockMoveInternalsComponent extends PageComponent {
  @Input() public filter: string | string[] = "";
  public expand: Array<string> = ['ResponsibleUserId', 'Statuses', 'CurrentStatusLink.StatusId'];

  @Input() public canRefresh: boolean = false;
  @Input() public canDelete: boolean = false;
  @Input() public delete: Function = (e: any) => { };

  @ViewChild('createModal') createModal?: DocumentCreateModalComponent
  @ViewChild('grid') grid?: StockMoveInternalGridComponent;
  @ViewChild("confirmModal") confirmModal?: ConfirmModalComponent;
  @ViewChild("statusModal") statusModal?: StockMoveInternalStatusSelectModalComponent;

  // ContextMenuItemAction
  // ---------------------
  public contextMenuItems: ContextMenuItemAction[] = [
    { code: StockMoveInternalContextMenuItemActionCode.PrintToPDF, text: "Preview to PDF", icon: "print", onItemClick: (e: any) => this.onMenuItemClicked(e), visible: this.authService.hasPermission('stockMove.internalstockmoves.list.contextMenu.preview') },
    { code: StockMoveInternalContextMenuItemActionCode.PrintToZIP, text: "Download to ZIP", icon: "print", onItemClick: (e: any) => this.onMenuItemClicked(e), visible: this.authService.hasPermission('stockMove.internalstockmoves.list.contextMenu.preview') },
    { code: StockMoveInternalContextMenuItemActionCode.Status, text: "Change status", icon: "edit", onItemClick: (e: any) => this.onMenuItemClicked(e), visible: this.authService.hasPermission('stockMove.internalstockmoves.list.contextMenu.changeStatus') },
  ];

  constructor(
    public stockMoveInternalsService: StockMoveInternalsService,
    public override activatedRoute: ActivatedRoute,
    private stockMoveInternalHeaderHeaderStatusesService: StockMoveInternalHeaderHeaderStatusesService,
    public override authService: AuthService
  ) { super(); }

  public onAddButtonClicked() {
    this.createModal?.open();
  };

  public async onCreateValidated() {
    var third = this.authService.user?.ThirdId;
    if (!third || !third.Id) {
      NotificationsService.sendErrorMessage("User is not linked to a third");
      return;
    }
    if (third.Blocked == true) {
      NotificationsService.sendErrorMessage("Third is blocked");
      return;
    }
    this.router.navigateByUrl('/stockmoves/internalstockmoves/new?ThirdId=' + third.Id );
  }

  // ContextMenu
  // -----------
  public async onMenuItemClicked(e: ContextMenuItemClickEvent) {

    if (!this.grid) return;

    switch (e.itemData.code) {
      // Printing
      // ---------
      case StockMoveInternalContextMenuItemActionCode.PrintToPDF:
        this.showConfirmModal("Would you like preview selected rows?", e.itemData);
        break;
      case StockMoveInternalContextMenuItemActionCode.PrintToZIP:
        this.showConfirmModal("Would you like download selected rows?", e.itemData);
        break;
      case StockMoveInternalContextMenuItemActionCode.Status:
        this.showStatusModal("Would you like change status selected rows?", e.itemData);
        break;
    }
  }

  private showConfirmModal(text: string, data: ContextMenuItemAction) {
    if (!this.confirmModal) return;

    this.confirmModal.title = data.text ? data.text : "Confirm";
    this.confirmModal.content = text;
    this.confirmModal.open({ rows: this.grid?.getSelectedRows(data.rowData), action: data.code });
  }
  private showStatusModal(text: string, data: ContextMenuItemAction) {
    if (!this.statusModal) return;

    this.statusModal.title = data.text ? data.text : "Confirm";
    this.statusModal.content = text;
    this.statusModal.open({ rows: this.grid?.getSelectedRows(data.rowData), action: data.code });
  }

  public async onConfirmModalValidated(modalData: { rows: StockMoveInternal[], action: string } | any) {
    switch (modalData.action) {
      case StockMoveInternalContextMenuItemActionCode.PrintToPDF:
        await this.stockMoveInternalsService.printRows(modalData.rows, "pdf", "StockMoveInternal","");
        break;
      case StockMoveInternalContextMenuItemActionCode.PrintToZIP:
        await this.stockMoveInternalsService.printRows(modalData.rows, "zip", "StockMoveInternal","");
        break;
      case StockMoveInternalContextMenuItemActionCode.Status:
        await this.updateStatus(modalData.rows, modalData.InternalStatus);
        break;
    }

    this.grid?.refresh();
    this.confirmModal?.close();
    this.statusModal?.close();
  }
  // ------------------------------------------------------------------------------------------------

  // Actions
  // -------
  private async updateStatus(selectedRows: StockMoveInternal[], status: StockMoveInternalHeaderStatus) {
    if (!this.stockMoveInternalsService.canUpdateStatus(selectedRows, status)) return;
    selectedRows.sort((a, b) => { return a.Date.getTime() - b.Date.getTime(); });

    for (var element of selectedRows) {
      if (element.Id) {
        const link: any = {
          HeaderId: { Id: element.Id },
          StatusId: { Id: status.Id },
          Date: new Date()
        };
        await this.updateDocumentStatus(link);
      }
    }
    NotificationsService.sendSuccess('Status updated');
  }
  private async updateDocumentStatus(link: any) {
    await this.stockMoveInternalHeaderHeaderStatusesService.insert(this.stockMoveInternalHeaderHeaderStatusesService.format(link));
  }
}